// @ts-ignore
import VueTippy, { TippyComponent } from "vue-tippy";
import Vue from "vue";

Vue.use(VueTippy, {
  directive: "tippy",
  flipDuration: 0
});

Vue.component("VTippy", TippyComponent);